// Installation script generated by Podsights
(function(w, d){
  var id='pdst-capture', n='script';
  if (!d.getElementById(id)) {
    w.pdst =
      w.pdst ||
      function() {
        (w.pdst.q = w.pdst.q || []).push(arguments);
      };
    var e = d.createElement(n); e.id = id; e.async=1;
    e.src = 'https://cdn.pdst.fm/ping.min.js';
    var s = d.getElementsByTagName(n)[0];
    s.parentNode.insertBefore(e, s);
  }
  w.pdst('conf', { key: 'c2fb95b82c02454ab1ee513e3754e0be' });
  w.pdst('view');
})(window, document);

function pdstColATC(
  evt, 
  productTitle, 
  variantId, 
  variantPrice, 
  variantTitle, 
  variantType,
  variantVendor ){
  var btn = evt.target;
  var page_url = window.location.href;
 // console.log("collection");
  pdst('addtocart', {
    value: variantPrice, // price
    currency: 'USD',
    // optional product information for advanced analytics.
    product_id: variantId,
    product_name: productTitle,
    product_vendor: variantVendor,
    variant_id: variantId,
    variant_name: variantTitle,
    product_type: variantType,
  });
 // console.log("collection-2"+ productTitle + variantId + variantPrice + variantType + variantTitle) ;
};

//Podsight ATC Event
function pdstATC(
    evt,
    productId,
    productTitle,
    productVendor,
    variantId,
    variantName,
    productType
  ){
  var psdtPdpVariantPrice = document.querySelector(".price-item").textContent.replace('$','');
  var psdtPdpQuantity = document.querySelector(".quantity__input").value;
  console.log(psdtPdpQuantity);
  pdst('addtocart', {
    value: psdtPdpVariantPrice, // price
    currency: 'USD',
    // optional product information for advanced analytics.
    quantity: psdtPdpQuantity,
    product_id: productId,
    product_name: productTitle,
    product_vendor: productVendor,
    variant_id: variantId,
    variant_name: variantName,
    product_type: productType
  });
};  